module.exports = __webpack_public_path__ + "media/images/emblems/Coldrerio-coat_of_arms-2f5854bd0d65c45c6ab12a2198097ee0.svg";